import PropTypes from 'prop-types';
import './Error.css';

const Error = ({ message, onRetry }) => {
  return (
    <div className="error">
      <div className="error__icon">!</div>
      <div className="error__message">{message}</div>
      {onRetry && (
        <button className="error__retry" onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
};

Error.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func
};

export default Error;
